import React from 'react';
import { useOutletContext } from 'react-router-dom';
import InfoCards from './InfoCards';

function InfoCardsOutlet() {
  const [orderData, currentView] = useOutletContext();

  return (
    <InfoCards
      style={{
        marginTop: '1rem',
      }}
      data={orderData}
      currentView={currentView}
    />
  );
}

export default InfoCardsOutlet;
